__turbopack_context__.v({
  "bottomImages": "styles-module-scss-module__8d_iBq__bottomImages",
  "componentContainer": "styles-module-scss-module__8d_iBq__componentContainer",
  "contentContainer": "styles-module-scss-module__8d_iBq__contentContainer",
  "imageContainer": "styles-module-scss-module__8d_iBq__imageContainer",
  "imagesContainer": "styles-module-scss-module__8d_iBq__imagesContainer",
  "reasonsContainer": "styles-module-scss-module__8d_iBq__reasonsContainer",
  "reasonsContent": "styles-module-scss-module__8d_iBq__reasonsContent",
  "short": "styles-module-scss-module__8d_iBq__short",
  "topImages": "styles-module-scss-module__8d_iBq__topImages",
});
